import React, { useState } from 'react';
import { Phone, MapPin, Clock, Shield, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="relative bg-navy text-white pt-14 pb-10 overflow-hidden" data-id="element-107">
        {/* Background Image with heavy overlay */}
        <div className="absolute inset-0 z-0 opacity-20" data-id="element-108">
          <img src="https://cdn.magicpatterns.com/uploads/by7ySk3Vwp8eGKKNBRRr96/fOTO_DE_ANGEL_INSURANCE_CON_FONDO_DEL_MAR_PUESTA_DEL_SOL.png" alt="Background" className="w-full h-full object-cover object-center grayscale" data-id="element-109" />
          <div className="absolute inset-0 bg-navy/90 mix-blend-multiply" data-id="element-110"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10" data-id="element-111">
          <div className="flex flex-col items-center text-center mb-16" data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/5T16zCVHXm8iCRBeXBiqc1/Logo_de_angel_insurance_con_Dorado_claro_Este_si.png" alt="Angel Insurance Logo" className="h-24 object-contain mb-8" data-id="element-113" />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 w-full max-w-4xl border-t border-b border-white/10 py-10" data-id="element-114">
              <div className="flex flex-col items-center gap-3" data-id="element-115">
                <Phone className="text-gold" size={24} data-id="element-116" />
                <a href="tel:8134034867" className="text-xl font-bold hover:text-gold transition-colors" data-id="element-117">
                  (813) 403-4867
                </a>
              </div>

              <div className="flex flex-col items-center gap-3" data-id="element-118">
                <MapPin className="text-gold" size={24} data-id="element-119" />
                <p data-id="element-120">
                  3840 W Humphrey St
                  <br data-id="element-121" />
                  Tampa, FL 33614
                </p>
              </div>

              <div className="flex flex-col items-center gap-3" data-id="element-122">
                <Clock className="text-gold" size={24} data-id="element-123" />
                <p data-id="element-124">
                  Abierto de Lunes a Viernes
                  <br data-id="element-125" />
                  Desde las 9 AM
                </p>
              </div>
            </div>
          </div>

          <div className="text-center space-y-6" data-id="element-126">
            <div className="flex items-center justify-center gap-3 text-gold text-2xl font-serif font-bold" data-id="element-127">
              <Shield size={28} data-id="element-128" />
              <p data-id="element-129">Tu Comunidad. Tu Idioma. Tu Protección.</p>
            </div>

            <div className="space-y-4" data-id="element-130">
              <p className="text-gray-400 text-sm" data-id="element-131">
                &copy; {new Date().getFullYear()} Angel Insurance of Florida.
                Todos los derechos reservados.
              </p>

              <div className="flex items-center justify-center gap-3 text-sm text-gray-400" data-id="element-132">
                <button onClick={() => setActiveModal('privacy')} className="hover:text-gold transition-colors" data-id="element-133">
                  Política de Privacidad
                </button>
                <span data-id="element-134">•</span>
                <button onClick={() => setActiveModal('terms')} className="hover:text-gold transition-colors" data-id="element-135">
                  Términos de Servicio
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <AnimatePresence data-id="element-136">
        {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-137">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-138" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-white text-navy w-full max-w-2xl max-h-[80vh] rounded-2xl shadow-2xl overflow-hidden flex flex-col" data-id="element-139">
              <div className="flex justify-between items-center p-6 border-b border-gray-100" data-id="element-140">
                <h3 className="text-2xl font-serif font-bold text-navy" data-id="element-141">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500 hover:text-navy" data-id="element-142">
                  <X size={24} data-id="element-143" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto text-gray-700 space-y-4 text-sm md:text-base" data-id="element-144">
                {activeModal === 'privacy' ? <>
                    <p data-id="element-145">
                      <strong data-id="element-146">Última actualización:</strong>{' '}
                      {new Date().toLocaleDateString('es-ES')}
                    </p>
                    <p data-id="element-147">
                      En Angel Insurance of Florida, respetamos su privacidad y
                      estamos comprometidos a proteger sus datos personales.
                      Esta política de privacidad explica cómo recopilamos,
                      usamos y compartimos información sobre usted cuando
                      utiliza nuestro sitio web y nuestros servicios.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-148">
                      1. Información que recopilamos
                    </h4>
                    <p data-id="element-149">
                      Recopilamos información que usted nos proporciona
                      directamente, como cuando solicita una cotización, se
                      comunica con nosotros o utiliza nuestros servicios. Esto
                      puede incluir su nombre, dirección, número de teléfono,
                      correo electrónico y detalles relevantes para sus
                      necesidades de seguro.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-150">
                      2. Cómo utilizamos su información
                    </h4>
                    <p data-id="element-151">
                      Utilizamos la información que recopilamos para
                      proporcionar, mantener y mejorar nuestros servicios,
                      procesar sus solicitudes de cotización, comunicarnos con
                      usted y cumplir con nuestras obligaciones legales.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-152">
                      3. Compartir información
                    </h4>
                    <p data-id="element-153">
                      No vendemos su información personal. Podemos compartir su
                      información con proveedores de seguros asociados
                      exclusivamente con el propósito de obtener cotizaciones y
                      procesar pólizas en su nombre.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-154">4. Seguridad</h4>
                    <p data-id="element-155">
                      Tomamos medidas razonables para ayudar a proteger la
                      información sobre usted contra pérdida, robo, uso indebido
                      y acceso no autorizado.
                    </p>
                  </> : <>
                    <p data-id="element-156">
                      <strong data-id="element-157">Última actualización:</strong>{' '}
                      {new Date().toLocaleDateString('es-ES')}
                    </p>
                    <p data-id="element-158">
                      Bienvenido a Angel Insurance of Florida. Al acceder o
                      utilizar nuestro sitio web y servicios, usted acepta estar
                      sujeto a estos Términos de Servicio.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-159">
                      1. Uso de los Servicios
                    </h4>
                    <p data-id="element-160">
                      Usted acepta utilizar nuestros servicios solo para fines
                      legales y de acuerdo con estos Términos. La información
                      proporcionada en este sitio web es para fines informativos
                      generales y no constituye asesoramiento legal o financiero
                      vinculante.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-161">
                      2. Cotizaciones y Pólizas
                    </h4>
                    <p data-id="element-162">
                      Cualquier cotización proporcionada a través de nuestro
                      sitio web o por nuestros agentes es una estimación basada
                      en la información proporcionada. La cobertura final y las
                      primas están sujetas a la suscripción y aprobación de la
                      compañía de seguros emisora.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-163">
                      3. Propiedad Intelectual
                    </h4>
                    <p data-id="element-164">
                      El contenido, diseño y logotipos de este sitio web son
                      propiedad de Angel Insurance of Florida y están protegidos
                      por leyes de derechos de autor y marcas comerciales.
                    </p>
                    <h4 className="font-bold text-navy mt-6" data-id="element-165">
                      4. Limitación de Responsabilidad
                    </h4>
                    <p data-id="element-166">
                      Angel Insurance of Florida no será responsable de ningún
                      daño indirecto, incidental, especial o consecuente que
                      surja del uso o la incapacidad de usar nuestros servicios.
                    </p>
                  </>}
              </div>

              <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end" data-id="element-167">
                <button onClick={() => setActiveModal(null)} className="bg-navy hover:bg-navy/90 text-white px-6 py-2 rounded-full font-medium transition-colors" data-id="element-168">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}